import { render } from "./SignUpCancelledComponent.vue?vue&type=template&id=2f8ae6cd&scoped=true"
import script from "./SignUpCancelledComponent.vue?vue&type=script&lang=js"
export * from "./SignUpCancelledComponent.vue?vue&type=script&lang=js"

import "./SignUpCancelledComponent.vue?vue&type=style&index=0&id=2f8ae6cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8ae6cd"]])

export default __exports__